import { Check } from "lucide-react";
import { Section } from "@/components/ui/Section";
import { Reveal } from "@/components/common/Reveal";
import { CAPABILITIES } from "@/utils/constants";

export const Capabilities = () => (
  <Section id="capabilities" testId="capabilities-section" bg="ink">
    <Reveal>
      <p className="text-weld-glow font-semibold tracking-[0.25em] uppercase text-sm mb-3">What We Do</p>
      <h2 className="font-display text-5xl md:text-6xl text-white">Capabilities</h2>
    </Reveal>
    <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-4">
      {CAPABILITIES.map((c, i) => (
        <Reveal key={c} delay={(i % 3) * 0.05}>
          <div data-testid={`capability-${i}`} className="flex items-center gap-3 border-b border-white/10 pb-4 group">
            <span className="w-8 h-8 shrink-0 rounded-lg bg-weld/10 border border-weld/30 flex items-center justify-center group-hover:bg-weld/20 transition-colors">
              <Check className="text-weld-glow" size={16} />
            </span>
            <span className="text-white/85 font-medium">{c}</span>
          </div>
        </Reveal>
      ))}
    </div>
  </Section>
);
